import api from '../token';

export const ListMoeda = async () => {
  try {
    const response = await api.post('/getMoeda');
    return response.data;
  } catch (error) {
    
    return [];
  }
};

